import * as React from "react";
import CnpjInput from "../utils/CnpjInput";
import { Button, Classes, Collapse, Dialog, FormGroup, Tooltip, } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import { observer } from "mobx-react";
import { createViewModel, IViewModel } from "mobx-utils";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import Tour from "reactour";
import { observable } from "mobx";
import IntlCurrencyInput from "react-intl-currency-input";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";

const numeral = require("numeral");

require("../../assets/css/components/EmpresaForm.css");

interface IEmpresaFormProps {
}

@observer
export default class EmpresaCreatePlan extends React.Component<IEmpresaFormProps, any> {

  obs = observable({
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    detalhes_import_planilha: false as boolean,
    showErrors: false as boolean,
    showSuccess: false as boolean,
    resp_data : [] as any,
  
  })

  fileInputRef: any;

  constructor(props: IEmpresaFormProps) {
    super(props);

    AppStore.setTitle("Preencha o CNPJ");
    this.obs.empresa = createViewModel(newEmpresa());
    EmpresaStore.obs.valorPlano = null;
    EmpresaStore.obs.cnpj = ""
    this.fileInputRef = React.createRef();
  }

  async componentDidMount() {

    EmpresaStore.obs.working = false;

    await this.handleCertificateChange()
    this.obs.empresa = createViewModel(newEmpresa());
    this.setState({ filial: "" });

    this.forceUpdate();

    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let totalEmpresas = EmpresaStore.obs.count_empresas

    if (contaPermissao && totalEmpresas > 1) {
      return AppStore.setLocation("/empresas");
    }

    if (totalEmpresas < 4) {
      EmpresaStore.obs.isTourOpen = true
    }
  }

  handleCertificateChange = async () => {

    await EmpresaStore.count_empresas();

  };

  handleCancel = () => {
    AppStore.setLocation("/empresas");
  };

  handlePlano = (faixa: any) => {

    EmpresaStore.obs.valorPlano = faixa.faixa;

    EmpresaStore.obs.plano = faixa;

    EmpresaStore.obs.currentSteps = 2
  };

  handleConsultaCNPJ = async () => {
    EmpresaStore.obs.isTourOpen = false

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    let cnpjEmpresa = EmpresaStore.obs.cnpj;

    if (is_teste) {
      EmpresaStore.obs.valorPlano = 1;

      EmpresaStore.obs.plano = { faixa: 1, maximo: 100000, minimo: 0, valor: 19.9, armazenamento: 200 };
    }

    await EmpresaStore.buscaCNPJ(cnpjEmpresa);

  };

  handleBlocoPlano() {

    const faixasPlanos = [
      { faixa: 1, maximo: 100000, minimo: 0, valor: 19.9, armazenamento: 200 },
      { faixa: 2, maximo: 360000, minimo: 100000, valor: 29.9, armazenamento: 300 },
      { faixa: 3, maximo: 720000, minimo: 360000, valor: 49.9, armazenamento: 400 },
      { faixa: 4, maximo: 1800000, minimo: 720000, valor: 69.9, armazenamento: 500 },
      { faixa: 5, maximo: 3600000, minimo: 1800000, valor: 99.9, armazenamento: 800 },
      { faixa: 6, maximo: 4800000, minimo: 3600000, valor: 199.9, armazenamento: 1024 },
      { faixa: 7, maximo: 4980000, minimo: 4800000, valor: 229.9, armazenamento: 1024 },
      { faixa: 8, maximo: 5160000, minimo: 4980000, valor: 249.9, armazenamento: 1024 },
      { faixa: 9, maximo: 5520000, minimo: 5160000, valor: 269.9, armazenamento: 1024 },
      { faixa: 10, maximo: 6600000, minimo: 5520000, valor: 299.9, armazenamento: 1024 },
      { faixa: 11, maximo: 7800000, minimo: 6600000, valor: 399.9, armazenamento: 2048 },
      { faixa: 12, maximo: 9000000, minimo: 7800000, valor: 499.9, armazenamento: 2048 },
      { faixa: 13, maximo: 10000000, minimo: 9000000, valor: 699.9, armazenamento: 2048 },
    ];

    let planoSelecionado = faixasPlanos.find(faixa => EmpresaStore.obs.rendimento_mensal <= faixa.maximo);

    let maximo: number = 10000000
    let faixa = 13
    let armazenamento = 2048


    if (!planoSelecionado) {

      while (EmpresaStore.obs.rendimento_mensal > maximo) {

        faixa += 1
        armazenamento += 1024
        maximo += 5000000;

      }

      let valor = maximo * 0.0001109;

      planoSelecionado = { faixa: faixa, maximo: maximo, minimo: maximo - 5000000, valor: valor, armazenamento: armazenamento }

    }

    return (
      <>
        {EmpresaStore.obs.rendimento_mensal > 10000000 ?

          <MDBRow>
            <MDBCol md="12">
              <div className="blocoAssin blocoCreatePlan">
                <span className="descAssinPerfil">&nbsp;</span>
                <span className="priceAssinPerfil">A definir</span>
                <span className="periodoAssinPerfil">/ mês</span>
                <span className="descAssinPerfil">
                  Empresas com rendimentos superiores a 10 milhões devem entrar em contato com o suporte para mais informações e personalização do plano.<br /><br />
                  {`Até ${numeral(planoSelecionado.maximo).format('$ 0,0.00')} de valor calculado`} <br />
                  {`${numeral(planoSelecionado.armazenamento * 1000000).format("0 b")} de armazenamento`} <br />
                </span>
                <button
                  className="countAssinPerfil active5"
                  onClick={() => this.handleClick()}
                >
                  Contatar
                </button>
              </div>
            </MDBCol>
          </MDBRow>

          :

          <MDBRow>
            <MDBCol md="12">
              <div className="blocoAssin blocoCreatePlan">
                <span className="descAssinPerfil">{`${planoSelecionado.faixa}ª Faixa`}</span>
                <span className="priceAssinPerfil">{numeral(planoSelecionado.valor).format('$ 0,0.00')}</span>
                <span className="periodoAssinPerfil">/ mês</span>
                <span className="descAssinPerfil">
                  {`Até ${numeral(planoSelecionado.maximo).format('$ 0,0.00')} de valor calculado`} <br />{" "}
                  {`${numeral(planoSelecionado.armazenamento * 1000000).format("0 b")} de armazenamento`} <br />{" "}
                </span>
                <button
                  disabled={EmpresaStore.obs.buscando_cnpj}
                  className={EmpresaStore.obs.valorPlano != null && EmpresaStore.obs.valorPlano != 0 ? "countAssinPerfil active5" : "countAssinPerfil"}
                  onClick={() => this.handlePlano(planoSelecionado)}
                >
                  {EmpresaStore.obs.valorPlano != null && EmpresaStore.obs.valorPlano != 0 ? "Selecionado" : "Selecionar"}
                </button>
              </div>
            </MDBCol>
          </MDBRow>
        }

      </>
    );
  }

  handleClick = () => {

    window.open(`https://api.whatsapp.com/send?phone=54991893928&text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20os%20planos%20personalizados%20para%20empresas%20com%20rendimentos%20superiores%20a%2010%20milh%C3%B5es.`, '_blank');

  };

  handleExport = async () => {
  
    await EmpresaStore.exportPlanilhaModelo();

  };

  handleImport = async (e) => {
    const resp = await EmpresaStore.importPlanilhaEmpresa(e);
  
    if (resp && resp.ok) {
      this.obs.resp_data = resp;
  
      this.obs.resp_data.erros = resp.erros.map((erro) => {
        const campos = Object.keys(erro).filter(key => key !== "mensagem");
        const nomeCampo = campos[0];
        const valorCampo = erro[nomeCampo];
  
        return `${nomeCampo.toUpperCase()} : ${valorCampo} - ${erro.mensagem}`;
      });
  
      this.obs.detalhes_import_planilha = true;
    }
  };

  handleShowErrors() {
    this.obs.showErrors = !this.obs.showErrors

    this.obs.showSuccess = false
  }

  handleShowSuccess() {
    this.obs.showSuccess = !this.obs.showSuccess

    this.obs.showErrors = false

  }

  render() {
    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    const hanldeRendimento = (event, value, maskedValue) => {

      EmpresaStore.obs.valorPlano = null

      EmpresaStore.obs.rendimento_mensal = value
    }

    return (
      <>
        <div className="empresa-form">
          <MDBCol md="12">
            <MDBRow>
              {!is_teste &&
                <>
                  <Tour
                    onRequestClose={() => EmpresaStore.obs.isTourOpen = false}
                    steps={tourConfig}
                    isOpen={EmpresaStore.obs.isTourOpen}
                    goToStep={EmpresaStore.obs.currentSteps}
                    disableFocusLock={true}
                    disableInteraction={false}
                    rounded={4}
                  />

                  <MDBDropdown>
                    <MDBDropdownToggle caret className="btnDefault buttonExcelEmpresas">
                      Importar planilha empresas
                    </MDBDropdownToggle>
                  <MDBDropdownMenu basic>

                      <MDBDropdownItem onClick={() => this.handleExport()} className="actionMani">
                        <AppIcon size={18} name="download" style={{ marginRight: 5, color: "#000" }}
                        />
                        Baixar planilha modelo
                      </MDBDropdownItem>

                      <MDBDropdownItem onClick={() => this.fileInputRef.current.click()} className="actionMani">
                      <AppIcon size={18} name="note_add" style={{ marginRight: 5, color: "#000" }}
                        />
                        <input
                          type="file"
                          accept=".xlsx"
                          style={{ display: "none" }}
                          ref={this.fileInputRef}
                          onChange={(e) => this.handleImport(e)}
                        />
                        Importar Excel
                      </MDBDropdownItem>

                    </MDBDropdownMenu>
                  </MDBDropdown>

                  <MDBCol md="12" data-tut="faturamento">
                    <FormGroup>
                      <label className="bp3-label">
                        Rendimento Mensal
                      </label>

                      <IntlCurrencyInput
                        className="form-control"
                        onChange={hanldeRendimento}
                        value={EmpresaStore.obs.rendimento_mensal}
                        currency="BRL"
                        config={currencyConfig}
                      />
                    </FormGroup>
                  </MDBCol>

                  <MDBCol md="12" data-tut="plano">
                    {this.handleBlocoPlano()}
                  </MDBCol>
                </>
              }

              <MDBCol md="12" className="createPlancpj">
                <div style={{ display: "flex" }} className="mini-selects" data-tut="cnpj">
                  <FormGroup
                    label="Digite o CNPJ da Empresa"
                    labelInfo="(Obrigatório)"
                    labelFor="cnpj"
                    style={{ width: "100%" }}
                  >
                    <CnpjInput
                      onChange={val => EmpresaStore.obs.cnpj = val}
                      value={EmpresaStore.obs.cnpj}
                      disabled={EmpresaStore.obs.disable_input_cnpj}
                    />
                  </FormGroup>
                </div>

                {!is_teste ?

                  <div style={{ textAlign: "center", marginBottom: 50 }}>

                    <Tooltip position={"right-top"} className="tooltip-create-empresas" content={
                      <div>
                        <p><b>Obrigatório:</b></p>

                        <p>Plano Selecionado: {EmpresaStore.obs.valorPlano == null
                          ? <img src="/images/cancel.svg" width="12px" />
                          : <img src="/images/checked.png" width="12px" />}
                        </p>

                        <p>CNPJ: {EmpresaStore.obs.isValid
                          ? <img src="/images/checked.png" width="12px" />
                          : <img src="/images/cancel.svg" width="12px" />}
                        </p>
                      </div>
                    }>
                      <Button
                        className="btnCreateEmp btnCreatPlan"
                        onClick={this.handleConsultaCNPJ.bind(this)}
                        loading={EmpresaStore.obs.working}
                        data-tut="continuar"
                      >
                        Continuar
                      </Button>
                    </Tooltip>
                  </div>

                  :

                  <Button
                    className="btnCreateEmp btnCreatPlan"
                    onClick={this.handleConsultaCNPJ.bind(this)}
                    loading={EmpresaStore.obs.working}
                    data-tut="continuar"
                  >
                    Continuar
                  </Button>
                }
              </MDBCol>
            </MDBRow>
          </MDBCol>

        <Dialog isOpen={this.obs.detalhes_import_planilha} title="Detalhes da Importação" onClose={() => {this.obs.detalhes_import_planilha = false; this.obs.showErrors = false}} className={this.obs.showErrors ? "import_error" : "import_pass"} >
        <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="5">
                <div>
                  <h3 className="arquivosProcessados">
                    <span className="roundCount">{this.obs.resp_data.total_dados}</span>{" "}
                      Total de cadastros
                  </h3>
                  <h3 className="arquivosProcessados">
                    <span className="roundCount">{this.obs.resp_data.importados}</span>{" "}
                      Cadastros importados
                  </h3>
                  <h3 className="arquivosProcessados">
                    <span className={(this.obs.resp_data.total_erros >= 1)
                      ? "roundCount roundCountError"
                      : "roundCount roundNotError"}
                    > {this.obs.resp_data.total_erros}</span>{" "}
                    Linha(s) com erro(s)
                  </h3>
                  {this.obs.resp_data.total_erros ?
                    <MDBBtn
                      onClick={() => this.handleShowErrors()}
                      className="btnDefault btnBuscarNfe erroCalculoBtn"
                      style={{ marginTop: 25, marginRight: 25 }}
                    >
                      {this.obs.showErrors ? "Ocultar" : "Mostrar"} erros
                    </MDBBtn> : <>
                    </>
                  }
                  {this.obs.resp_data.importados ?
                    <MDBBtn
                      onClick={() => this.handleShowSuccess()}
                      className="btnDefault btnBuscarNfe erroCalculoBtn"
                      style={{ marginTop: 25, marginRight: 25 }}
                    >
                      {this.obs.showSuccess ? "Ocultar" : "Mostrar"} importados
                    </MDBBtn> : <>
                    </>
                  }
                </div>
              </MDBCol>

              <MDBCol md="7">
                <div style={{ marginTop: -65 }}>
                  <Collapse isOpen={this.obs.showErrors}>
                    <div className="flash-error" style={{maxHeight: 400}}>
                      {this.obs.resp_data.total_erros &&
                        <>
                          <div style={{ textAlign: "center", marginTop: 0 }}>
                            <img
                              src="/images/erro_calculo.svg"
                              width={50}
                              style={{ display: "inline-block" }}
                            />
                            <h3>Erros foram encontrados</h3>
                          </div>

                          <div style={{ height: 300, overflow: "auto" }}>
                            {this.obs.resp_data.erros.map(e => {
 
                              return (<p>{e}</p>)
                              
                            })}
                          </div>

                        </>
                      }
                    </div>
                  </Collapse>
                  <Collapse isOpen={this.obs.showSuccess}>
                    <div className="flash-error" style={{maxHeight: 400}}>
                      {this.obs.resp_data.importados &&
                        <>
                          <div style={{ textAlign: "center", marginTop: 0 }}>
                            <img
                              src="/images/pass_calculo.png"
                              width={50}
                              style={{ display: "inline-block" }}
                            />
                            <h3 style={{ color: "#46eb7d" }}>Empresas cadastradas com sucesso</h3>
                          </div>

                          <div style={{ height: 300, overflow: "auto" }}>
                            {this.obs.resp_data.criados.map(e => {
 
                              return (<p>{e}</p>)
                              
                            })}
                          </div>

                        </>
                      }
                    </div>
                  </Collapse>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" onClick={() => {this.obs.detalhes_import_planilha = false; this.obs.showErrors = false; this.obs.showSuccess = false}}/>
            </div>
          </div>
        </Dialog>

        <LoadingModal open={EmpresaStore.obs.loading_import} onClose={() => EmpresaStore.obs.loading_import = false} title={"Importando planilha"} />

        </div>

      </>
    );
  }
}

const tourConfig = [
  {
    selector: `[data-tut=\"faturamento\"]`,
    content: "Informe aproximadamente o faturamento da empresa que deseja cadastrar!",
  },
  {
    selector: `[data-tut=\"plano\"]`,
    content: "Selecione um plano para a Empresa que deseja Cadastrar!",
  },
  {
    selector: "[data-tut=\"cnpj\"]",
    content:
      `Digite o CNPJ da Empresa que deseja Cadastrar! `,
  },
  {
    selector: "[data-tut=\"continuar\"]",
    content: `Clique em Continuar para prosseguir com o cadastro! `,
  },
];
